import { FC } from 'react';
import { CourseCard } from './CourseCard';
import { useCourseListContext } from '@new/common/contexts/CourseListContext';
import { useCan } from '@new/casl';

interface CourseGridProps {
  readOnly?: boolean;
}

export const CourseGrid: FC<CourseGridProps> = ({ readOnly }) => {
  const { filteredCourses, searchQuery, degreeId } = useCourseListContext();
  const isStudent = useCan('start', 'Course');

  if (filteredCourses.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-(--neutral-black-NB600) [font-size:var(--fs-p3)]!">
          {searchQuery ? 'No courses found matching your search.' : 'No courses available.'}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5 self-stretch align-center">
      {filteredCourses.map((course) => {
        return (
          <CourseCard
            key={course.id}
            course={course}
            degreeId={degreeId}
            showMoreMenu={isStudent}
            readOnly={readOnly}
          />
        );
      })}
    </div>
  );
};
